import api from "./core";

const basePath = "api/core/Notifications";

export default {
  query(filter) {
    return api.post(`${basePath}`, filter, {
      "Hide-Loading": true
    });
  },
  create(data) {
    return api.put(`${basePath}`, data, {
      "Hide-Loading": true
    });
  },
  hasNewNotifications() {
    return api.get(`${basePath}/HasNewNotifications`, {
      "Hide-Loading": true
    });
  },
  sendPatientPortalLink(portalAccessId, email, phone, sendByEmail, sendBySms) {
    return api.post(`${basePath}/SendPatientPortalLink`, {
      portalAccessId,
      email,
      phone,
      sendByEmail,
      sendBySms
    });
  },
  remove(ids) {
    return api.post(`${basePath}/Remove`,ids, {
      "Hide-Loading": true
    });
  }
};
